





































































































	import { Vue, Component, Watch } from 'vue-property-decorator';
    import { store, StoreState, HellospokeContact ,AppSettings} from '../../store';
    import { mapState,mapActions  } from 'vuex';
    import VeeValidate from 'vee-validate';   
    import VueElementLoading from 'vue-element-loading'; 
    import {RotateSquare2} from 'vue-loading-spinner'; 
      import axios from 'axios'; 


	declare interface ContactInfoData {
        mode: "info" | "search";
        results: HellospokeContact[];
        temp_ContactList:HellospokeContact[];
        search_term: string;
        Error_Msg:false;
    }

 @Component({
        components: {
            RotateSquare2,VueElementLoading,NewContact,
            
        },
        computed: {
            ...mapState({
                'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
                'incomingCaller': (state: StoreState) => state.dashboard.incomingCaller,
                'contacts': (state: StoreState) => state.dashboard.contacts,
                'NewContact':(state: StoreState) => state.dashboard.newcontact_status, 
                'Number':(state: StoreState) => state.dashboard.newcontact_creat_Number, 
                'isLoading':(state: StoreState) => state.dashboard.contact_info_loader, 
            }),
            NewContact_Titl: function() {
                this.$data.NewContact_User.mobile =(this as any).Number;
                this.submitted=false;
                this.$data.Error_Msg=false;
                // return ''; 
            },
            
        },
         methods:{
         focusOut: function(event) {
            var str= this.$data.NewContact_User.main; 
            //Check if the input is of correct length
             let cleaned = ('' + str).replace(/\D/g, '');
             let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
              if (match) {
                  this.$data.NewContact_User.main=('(' + match[1] + ') ' + match[2] + '-' + match[3]) ;
            };
        },
         focusOutmobile: function(event) {
            var str= this.$data.NewContact_User.mobile; 
            //Check if the input is of correct length
             let cleaned = ('' + str).replace(/\D/g, '');
             let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
              if (match) {
                  this.$data.NewContact_User.mobile=('(' + match[1] + ') ' + match[2] + '-' + match[3]) ;
            };
        },
       fileChange(file) {
            // To check if file is an image
            if (!file.target.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
                alert('not an image');
                file.target.value = null
               // this.$emit('imageChanged', null)
                return;
            }
             this.$data.Newcropped_status=true;
            var reader = new FileReader();
            reader.readAsDataURL(file.target.files[0]);
            reader.onload = () => {
                this.$data.dialog = true;
                // bind the result of the file 
                // to croppie
                  var self= (this.$refs as any);
                   self.croppieRef.bind({
                            url: reader.result,
                    });
               
                file.target.value = null
            };
            reader.onerror = (error) => {
                console.log('Error: ', error);
            };
        },
       

        
     }
         
    })
	export default class NewContact extends Vue {
        Number!:null;
       
         data() {
            return {
                Newcropped_status:false,
                profile:"/img/icons/camera.png",
                imageupload:false,
                submitted: false,
                main_numstatus:false,
                mob_numstatus:false,
                mode: "info",
                results: [],
                temp_ContactList:[],
                search_term: '',
                Error_Msg:false,
                Email_status:'',
                Number_status:false,
                CreateContact_ByNumber:null,
                imagUploading:false,
                mainum_mobnum:false,
                NewContact_User: {
                    firstName  : '',
                    lastName   : '',
                    companyName: '',
                    main       :'',
                    extension  :'', 
                    mobile     :(this as any).Number,
                    customerid :'',
                    addline1   :'',
                    addline2   :'',
                    city       :'',
                    state      :'',
                    zip        :'',
                    email      :'',
                    selected   :0 // Default to private 
            },
            private_public:
            [
                { Name: "Private", Id: 0 },
                { Name: "Public", Id: 1 }
            ]
            } as ContactInfoData;
        }

      

        mounted()
        {
            this.$data.submitted =false;
        }

        isNumber(event, message) {
            if (!/\d/.test(event.key) &&  
                (event.key !== "." || /\./.test(message))     
            )  
                return event.preventDefault();  
            }
      
        created()
        {
                console.log('new con');
                this.$data.submitted = false;
                this.$data.Error_Msg=false;
        }

        fileUploaded(files) {
            var FileSize=files[0].size;
            var Max_fileSize=Math.round(FileSize / 1000000); //size in mb;
            if(Max_fileSize>4)
                {
                   alert('Attachment may not exceed 5MB.');
                }
           else{
                this.$data.sendingImage = true;
                 (this as any).imagUploading=true;
                let formData = new FormData();
                //JSON.parse(JSON.stringify((this as any).selectedContact))
                formData.append('file', files[0]);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.account.jwt;
                axios.post( `${AppSettings.API_HOST}uploadContactImage`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                    }
                ).then(r => {
                  
                    (this as any).profile= r.data.imageurl;
                    (this as any).imagUploading=false;
                    (this as any).imageupload=true;
                });
           }
        }
        crop() { 
            // Here we are getting the result via callback function
            // and set the result to this.cropped which is being 
            // used to display the result above.
               this.$data.sendingImage = true;
               (this as any).imagUploading=true;
              var self= (this.$refs as any);
              let options = {
                  format: 'jpeg', 
                  circle: true
              };
            self.croppieRef.result(options, (output) => { 
                this.$data.cropped = output;
                (this as any).profile=this.$data.cropped;
                    (this as any).imagUploading=false;
                    (this as any).imageupload=true;
              this.$data.Newcropped_status=false;

                console.log(output)
            });  
        }

    validatePhoneNumber(phoneNumber: any) {
            if(!phoneNumber) {
				return false;
			}
			if(typeof phoneNumber === "number") {
				phoneNumber = phoneNumber.toString();
			}
			//strip all potential nondigits
            phoneNumber = phoneNumber.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
             if(!(/[1-9]{1}[0-9]{9}/.test(phoneNumber)))
                {
                this.$data.Number_status=false;
                    return false;
                }
			//Allow US country code if supplied
			const re = /^1?\d{10}$/;
			if(!re.test(phoneNumber)) {
                this.$data.Number_status=false;
				return false;
		}
            this.$data.Number_status=true;
			return true;
    }
    
    validat_num(Number: any){
       let mob_number = Number//this.$data.NewContact_User.mobile;
           mob_number = mob_number.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
        if(mob_number.length === 10) {
           mob_number = `+1${mob_number}`;
         }
        else {
            mob_number = `+${mob_number}`;
        }
        return mob_number;
    }


    validateEmail(email: any) {
        //Breakdown of this Regex can be found here:
        //https://www.w3resource.com/javascript/form/email-validation.php
        //Seems to cover most all cases.
         const re =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;// /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(!re.test(email)) {
                this.$data.Email_status=false;
                return false;
            }
        this.$data.Email_status=true;
        return true;
    }

	_Cancel_NewContact(){
        this.$emit('cancel','cancel_event');  
        this.$data.submitted = false;
         this.$data.Error_Msg=false;
        this.$store.commit("SHOW_CONTACT_LIST", true);
        this.$store.commit("NEW_CONTACT_CREATE", false);
    }
    onblur(){
         this.$data.mainum_mobnum=false;
    }
	////   Create New Contact
    _OnSubmitNewContact(e) {
     
       // alert((this as any).profile)
                this.$data.submitted = true;
                this.$data.mainum_mobnum=true;
                this.$validator.validate().then(valid => {
                    this.$data.mainum_mobnum=this.$data.NewContact_User.main!=""||this.$data.NewContact_User.mobile!=""?false:true;
                    this.$data.Error_Msg=valid?false:true;
                     var regex = /^[A-Za-z0-9 ]+$/ ;
                     var fname=regex.test(this.$data.NewContact_User.firstName);
                   
                    if (valid && !this.$data.mainum_mobnum) {
                        var fname=regex.test(this.$data.NewContact_User.firstName);
                        var lname=regex.test(this.$data.NewContact_User.lastName);
                    if(this.$data.NewContact_User.firstName==""){
                        alert("Please enter first name .");
                        return;
                    }
                        if(this.$data.NewContact_User.lastName==""){
                        alert("Please enter last name ");
                        return;
                    }
                    {
                        if(this.$data.NewContact_User.mobile!=""&&this.$data.NewContact_User.main=="")
                        
                        if(!this.validatePhoneNumber(this.$data.NewContact_User.mobile)) {
                            this.$data.mob_numstatus=true;
                         alert("Please enter a valid phone number");
                        return;
                        }
                        else{this.$data.NewContact_User.mobile=this.validat_num(this.$data.NewContact_User.mobile);this.$data.mob_numstatus=false;}
                    }
                    
                    {
                       if(this.$data.NewContact_User.mobile==""&&this.$data.NewContact_User.main!="")
                       
                       if(!this.validatePhoneNumber(this.$data.NewContact_User.main)) {
                            this.$data.main_numstatus=true;
                            alert("Please enter a valid main number");
                            return;
                        }
                        else{this.$data.NewContact_User.main=this.validat_num(this.$data.NewContact_User.main);this.$data.main_numstatus=false; }
                    }
                    {
                        if(this.$data.NewContact_User.mobile!=""&&this.$data.NewContact_User.main!=""){
                        if(!this.validatePhoneNumber(this.$data.NewContact_User.mobile)) {
                            this.$data.mob_numstatus=true;
                         alert("Please enter a valid phone number");
                        return;
                        }
                        else{this.$data.NewContact_User.mobile=this.validat_num(this.$data.NewContact_User.mobile);this.$data.mob_numstatus=false;}
                        if(!this.validatePhoneNumber(this.$data.NewContact_User.main)) {
                             this.$data.main_numstatus=true;
                            alert("Please enter a valid main number");
                            return;
                        }
                        else{this.$data.NewContact_User.main=this.validat_num(this.$data.NewContact_User.main);this.$data.main_numstatus=false }
                        }
                    }
                    
                    {
                        let _Email=this.$data.NewContact_User.email;
                        if(this.$data.NewContact_User.email != '' && !this.validateEmail(this.$data.NewContact_User.email))
                        {
                            alert("Please enter a valid email address.");
                            return;
                        }
                            this.$data.NewContact_User.email=_Email;
                    }
                 if(this.$data.Email_status==''||this.$data.Email_status==true && this.$data.Number_status==true )  
                this.$store.commit('SHOW_CONTACT_INFOLOADER', true);
                    var Newcontact_data:any= {
                        fname        :  this.$data.NewContact_User.firstName,
                        lname        :  this.$data.NewContact_User.lastName,
                        coyname      :  this.$data.NewContact_User.companyName,
                        number       :  this.$data.NewContact_User.main,
                        extension    :  this.$data.NewContact_User.extension,
                        mobile       :  this.$data.NewContact_User.mobile,
                        custermerid  :  this.$data.NewContact_User.customerid,
                        line1        :  this.$data.NewContact_User.addline1,
                        line2        :  this.$data.NewContact_User.addline2,
                        city         :  this.$data.NewContact_User.city,
                        state        :  this.$data.NewContact_User.state,
                        zip          :  this.$data.NewContact_User.zip,
                        email        :  this.$data.NewContact_User.email,
                        private      :  (this.$data.NewContact_User.selected==0 ) ?true:false,
                    } 

                    if ((this as any).imageupload)
                        Newcontact_data.imageUrl=(this as any).profile;
                    this.$store.dispatch('addCaller', Newcontact_data).then(r => {
                    }).catch(() => {
                    });
                     var self=this;
                      this.$store.commit("CHANGE_SELECTED_CONTACT", null);
                    setTimeout(function(){
                        self.$emit('cancel','refresh');  
                        this.$store.commit('SHOW_CONTACT_INFOLOADER', false);
                    }, 2000);
                       }  
                });  
     }

    }
